import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const PATH_PARTICIPANTE = "/participante/";
const SEND_PASWORD = "/participante/send-password";
const LOGIN = "/participante/login";
const ME_PATH = "/participante/me";
const FORM_DATA_PATH = "/participante/form-data";
const NO_VALIDATION = "novalidation/";
const DOWNLOAD_CREDENCIAL = "/files/credencial";
const PATH_GET_BY_TYPE = "/participante/get-by-type";
const DOWNLOAD_CONSTANCIA = "/files/constancias-ingreso/";

export const storeParticipanteAcount = async (body) => {
  const response = await HTTP_REQUEST.post(SEND_PASWORD, body);
  return handleResponse(response);
};

export const login = async (body) => {
  const response = await HTTP_REQUEST.post(LOGIN, body);
  return handleResponse(response);
};

export const me = async () => {
  const response = await HTTP_REQUEST.post(ME_PATH);
  return handleResponse(response);
};

export const getFormData = async () => {
  const response = await HTTP_REQUEST.get(FORM_DATA_PATH);
  return handleResponse(response);
};

export const downloadCredencialUncounted = async (nrodocumento) => {
  const response = await HTTP_REQUEST.getFile(
    DOWNLOAD_CREDENCIAL,
    `fileName=${nrodocumento}-CREDENCIAL.pdf`
  );
  return response; // return a blob
};

export const downloadCredencialCounted = async (nrodocumento) => {
  const response = await HTTP_REQUEST.getFile(
    DOWNLOAD_CREDENCIAL,
    `fileName=${nrodocumento}-CREDENCIAL.pdf&counted=true&nrodocumento=${nrodocumento}`
  );
  return response; // return a blob
};

export const updateOne = async (body, participanteId) => {
  const response = await HTTP_REQUEST.put(PATH_PARTICIPANTE, body, participanteId);
  return handleResponse(response);
};

export const updateUnsafe = async (body, participanteId) => {
  const response = await HTTP_REQUEST.put(PATH_PARTICIPANTE + NO_VALIDATION, body, participanteId);
  return handleResponse(response);
};

export const downloadExcelFile = async () => {
  const response = await HTTP_REQUEST.getFile("/participante-download");
  return response; // return a blob
};

export const downloadDetallado = async () => {
  const response = await HTTP_REQUEST.getFile("/participante-download-detallado");
  return response; // return a blob
};

export const downloadExcelByTipoParticipante = async (idtipoparticipante) => {
  const response = await HTTP_REQUEST.getFile("/participante-download/", idtipoparticipante);
  return response; // return a blob
};

export const getByDNI = async (nrodocumento) => {
  const response = await HTTP_REQUEST.get(PATH_PARTICIPANTE, nrodocumento);
  return handleResponse(response);
};

export const getByType = async (idtipoparticipante) => {
  /* eslint-disable no-unused-vars */
  // const [_key, { idtipoparticipante }] = queryKey;
  const response = await HTTP_REQUEST.post(PATH_GET_BY_TYPE, { idtipoparticipante });
  return handleResponse(response);
};

export const downloadConstanciaCounted = async (documentNumber) => {
  const response = await HTTP_REQUEST.getFile(
    DOWNLOAD_CONSTANCIA,
    `fileName=${documentNumber}-CONSTANCIA.jpg&counted=true&documentNumber=${documentNumber}`
  );
  return response; // return a blob
};
